import { store } from '@utils/configStore'
import { webNotificationManagementReducer } from './slice'

export const injectWebNotificationManagementStore = () => store.injectReducer('webNotificationManagement', webNotificationManagementReducer)
